import { useSearchParams, useNavigate } from "react-router-dom"
import { useState } from "react"
import api from "../lib/axios"
import { Input } from "../components/ui/input"
import { Button } from "../components/ui/button"

export default function ResetPassword() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get("token") || ""
  const nav = useNavigate()
  const [pw, setPw] = useState("")
  const [confirm, setConfirm] = useState("")
  const [err, setErr] = useState("")

  const handleSave = async () => {
    if (pw !== confirm) return setErr("Passwords don’t match.")
    try {
      await api.post("/auth/reset-password", { token, new_password: pw })
      nav("/", { replace: true })          // back to login
    } catch (e:any) {
      setErr(e.response?.data?.detail || "Reset failed.")
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="space-y-4 w-full max-w-sm">
        <h2 className="text-xl font-bold">Choose a new password</h2>
        {err && <p className="text-red-600">{err}</p>}
        <Input type="password" placeholder="New password" value={pw}
               onChange={e => setPw(e.target.value)} />
        <Input type="password" placeholder="Confirm password" value={confirm}
               onChange={e => setConfirm(e.target.value)} />
        <Button onClick={handleSave} className="w-full bg-black text-white">
          Save
        </Button>
      </div>
    </div>
  )
}
